<template>
  <EquityChart :reuqestData="reuqestData" />
</template>

<script>
import EquityChart from '@/components/EquityChart.vue'

export default {
  name: 'equityChart',
  components: { EquityChart },
  data() {
    return {
        token:'',
        reuqestData: {
          title: this.$route.query.title || '',
          creditCode: this.$route.query.creditCode || '',
          stockCode: this.$route.query.stockCode || '',
          type: this.$route.query.type || '',
        },
    }
  },
  mounted() {
    this.token = this.decodeURI(this.$route.query.token);
    localStorage.setItem('token', this.token);
  },
  methods: {
    // base64解密
		decodeURI(text) {
			text = text.replace(/%3D/ig, '=').replace(/-/g, '+').replace(/_/g, '/');
			return window.atob(text);
		},
  }
}
</script>

<style>
</style>
